
import {  Flex } from "@chakra-ui/react";
import { BilhetePagamento } from "../../hooks/pagamento/usePedido";
import { DetalhesBilhete } from "./DetalhesBilhete";

interface Props {
  bilhetes: BilhetePagamento;
  isDetail ?: boolean;
}

export function Bilhetes({ bilhetes, isDetail = false }: Props) {
  const ida = Array.isArray(bilhetes?.ida) ? bilhetes.ida : [];
  const volta = Array.isArray(bilhetes?.volta) ? bilhetes.volta : [];

  return (
    <Flex gap={2} flexDir={{xs: 'column', 'xl': 'row'}}>
      {ida.map((servico, servicoIndex) => (
        (Array.isArray(servico.viagens) ? servico.viagens : []).map((detalhes, viagemIndex) => (
          <DetalhesBilhete key={`detalhe-ida-${servicoIndex}-${viagemIndex}`} isDetail={isDetail} contexto={'ida'} detalhe={detalhes}/>
        ))
      ))}
      {volta.map((servico, servicoIndex) => (
        (Array.isArray(servico.viagens) ? servico.viagens : []).map((detalhes, viagemIndex) => (
          <DetalhesBilhete key={`detalhe-volta-${servicoIndex}-${viagemIndex}`} isDetail={isDetail} contexto={'volta'} detalhe={detalhes}/>
        ))
      ))}
    </Flex>
  );
}
